import { useAnalytics } from '@lib/analytics/analyticsContext';
import { RefObject, useEffect, useMemo, useRef } from 'react';

import { VideoAnalytics } from '../utils/videoAnalytics';

const SAMPLING_RATE = 0.5;

export const useVideoAnalytics = (vid: RefObject<HTMLVideoElement>) => {
    const videoAnalytics = useRef<VideoAnalytics | null>(null);
    const { track } = useAnalytics();
    const shouldMonitor = useMemo(() => Math.random() < SAMPLING_RATE, []);
    useEffect(() => {
        if (!vid.current) return;
        if (!shouldMonitor) return;
        videoAnalytics.current = new VideoAnalytics(vid.current, track);
    }, [vid, track, shouldMonitor]);

    return { videoAnalytics: videoAnalytics.current };
};
